export class FilesTreeService {
  constructor($http, $rootScope) {
    this.$http = $http;
    this.$rootScope = $rootScope;
  }

  load(path, callback) {
    if (!this.$rootScope.isPdf) return this.$http.get(`/files/folder-${path? path: ''}`)
      .then(({
        data,
        status
      }) => {
        if (!path) this.data = data;
        if (callback) callback(data);
      });
  }
}



// WEBPACK FOOTER //
// ./src/view/filetree/files-tree.service.js